/**
 * 独家、热点分享页面的公共逻辑：
 * 1. 添加页面底部 UpgradeBottomSlides 组件
 * 2. 包裹 errorBoundary
 * 3. 微信分享设置
 */

import React, { PureComponent, Fragment } from 'react';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import styles from './index.css';

// const BottomSliders = errorBoundary(({ slidesConfig }) => (
//     <div className={styles.bottomSlide}>
//         <UpgradeBottomSlides content={slidesConfig} />
//     </div>
// ));

export const withBottomSlide = function withBottomSlide(Component) {
    const InnerComponent = errorBoundary(Component);

    class withBottomSlide extends PureComponent {
        state = {
            shareConfig: undefined,
            slidesConfig: undefined,
        };

        static propTypes = {
            content: PropTypes.object
        };

        setWechatConfig = config => {
            this.setState({
                shareConfig: config,
            });
        };

        getFooterSlideData = config => {
            let insertSlideArr = [];
            let slideNum = 4;
            const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
            const {
                content: { unfoldType },
            } = this.props;
            const wxLaunch = (unfoldType && unfoldType.wxLaunch) || {};
            const wxLaunchConfig = {
                wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
                wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
            };

            for (let i = 1; i < slideNum; i++) {
                insertSlideArr.push({
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            to: true,
                            ref: config.staId ? config.staId : encodeURIComponent(document.referrer),
                            kind: 'contents',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                            downurl:
                                config.downurl ||
                                'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                        },
                    },
                    downloads: isVideoShare
                        ? {}
                        : {
                              download:
                                  'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                              downloadAd:
                                  'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                          },
                    wxLaunchType: wxLaunchConfig.wxLaunchType,
                    wxLaunchSwitch: wxLaunchConfig.wxLaunchSwitch,
                    kind: 'share01'
                });
            }

            this.setState({
                slidesConfig: {
                    isVideoShare,
                    apiConfig: {
                        type: 'all',
                        from: config.from,
                        proid: 'ifeng_share',
                        id: config.id,
                        n: slideNum,
                        title: config.title,
                    },
                    insertSlideArr,
                },
            });
        };

        render() {
            const { shareConfig, slidesConfig } = this.state;

            return (
                <Fragment>
                    {shareConfig && <QQShare content={shareConfig} />}
                    <InnerComponent
                        {...this.props}
                        setWechatConfig={this.setWechatConfig}
                        getFooterSlideData={this.getFooterSlideData}
                    />
                    {/* {slidesConfig && <PageBottomBrand isVideoShare={isVideoShare} slidesConfig={slidesConfig} />} */}
                </Fragment>
            );
        }
    }

    return errorBoundary(withBottomSlide);
};
